module.exports = __webpack_public_path__ + "img/fooimg.3e402665.png";